
function sameHeightForAllElements(items, outerHeight) {
    if (jQuery(items).size() > 0) {
        var max_height = 0;
        jQuery(items).each(function (k, item) {
            var height = jQuery(item).outerHeight(outerHeight);
            if (height > max_height) {
                max_height = height;
            }
        });
        jQuery(items).each(function (k, item) {
            jQuery(item).css({
                'height': max_height
            }).addClass('modified_height');
        });

    }
}

function offersCarousel() {
    if (!globalVar.is_phone) {
        sameHeightForAllElements('.offer_wrap .content', true);
        jQuery('.offer_wrap .content').trigger('builder_offer_height_modified')
    }
    var wrap = jQuery('#offers_page .offers_carousel');

    wrap.on("init", function () {
        lazyLoadInstance.update();
        wrap.trigger('builder_offer_init');
    });

    if(wrap.find('.arrow').length === 0){
        wrap.append('<a class="arrow hidden-xs prev" href="javascript:;"></a>' +
            '<a class="arrow hidden-xs next" href="javascript:;"></a>');
    }

    wrap.find('.offers_container').not('.slick-initialized').slick({
        fade: false,
        autoplay: false,
        arrows: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        nextArrow: wrap.parent().find('.next'),
        prevArrow: wrap.parent().find('.prev'),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    centerMode: true,
                    centerPadding: '50px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });
}

jQuery('.offers_carousel > div').on('builder_offers_ready', function () {
    offersCarousel();
});
